/** Primary profile first, then alphabetical by name. */
export function sortFitnessProfilesForDisplay(profiles = []) {
	return [...profiles].sort((a, b) => {
		if (a.is_primary && !b.is_primary) return -1;
		if (!a.is_primary && b.is_primary) return 1;
		return String(a.name || '').localeCompare(String(b.name || ''), undefined, { sensitivity: 'base' });
	});
}
